import { reactive } from "vue";

export default reactive({
  organizations: [],
  assignableOrganizations: [],
  projects: [], 
  warehouses: [],
  warehouseTypes: [],
  orderTypes: [ 
    { label: "Inbound", value: "INBOUND" },
    { label: "Outbound", value: "OUTBOUND" }
  ],
  orderClasses: [
    { label: "Inbound ASN", value: "InASN", relatedOrderTypeValue: "INBOUND" },
    { label: "Drop Ship Inbound ASN", value: "InDSASN", relatedOrderTypeValue: "INBOUND" },
    { label: "Sales Order", value: "SO", relatedOrderTypeValue: "OUTBOUND" },
    { label: "Retail Sales Order", value: "SO-RET", relatedOrderTypeValue: "OUTBOUND" },
    { label: "Drop Ship Sales Order", value: "SO-DS", relatedOrderTypeValue: "OUTBOUND" }
  ],
  orderStatus: [
    { label: "All Active", value: "ALL_ACTIVE", relatedOrderTypeValues: [ "", "INBOUND", "OUTBOUND" ] },
    { label: "All Completed", value: "ALL_COMPLETED", relatedOrderTypeValues: [ "", "INBOUND", "OUTBOUND" ] },
    { label: "Cancelled", value: "CANCEL", relatedOrderTypeValues: [ "", "INBOUND", "OUTBOUND" ] },
    { label: "Error", value: "ERROR", relatedOrderTypeValues: [ "", "INBOUND", "OUTBOUND" ] },
    { label: "Finalized", value: "FINALIZED", relatedOrderTypeValues: [ "", "INBOUND" ] },
    { label: "On Pick", value: "ON_PICK", relatedOrderTypeValues: [ "", "OUTBOUND" ] },
    { label: "Open", value: "OPEN", relatedOrderTypeValues: [ "", "OUTBOUND" ] },
    { label: "Pending", value: "PENDING", relatedOrderTypeValues: [ "", "INBOUND" ] },
    { label: "Processing", value: "PROCESSING", relatedOrderTypeValues: [ "", "INBOUND", "OUTBOUND" ] },
    { label: "Shipped", value: "SHIPPED", relatedOrderTypeValues: [ "", "OUTBOUND" ] }
  ],
  orderDateTypes: [
    { label: "Entered Date", value: "createdAt" },
    { label: "Expected Date", value: "requestedWarehouseDate" },
    { label: "Completion Date", value: "fulfillmentDate" }
  ],
  orderPaymentTerms: [
    { label: "Pre-paid", value: "PrePaid" },
    { label: "Collect", value: "Collect" },
    { label: "3rd Party Parcel Billing", value: "ThirdParty" }
  ],
  orderNoteTypes: [],
  orderMediaTypes: [],
  orderSSCCLabelTypes: [
    { label: "Package", value: "package", compatibleTemplateType: "SHIPPING_PACKAGE_LABEL" },
    { label: "Mixed Package", value: "mixed-package", compatibleTemplateType: "SHIPPING_PACKAGE_LABEL" }
  ],
  trackedExceptionTypes: [],
  trackedExceptionResponsiblePartyTypes: [],
  transportCompanies: [],
  templates: undefined,
  templateTypes: [],
  templateJobNames: [],
  scheduledReportCreatedBys: [],
  partners: [],
  partnerTransactionClasses: [],
  partnerTransactionEvents: [],
  partnerTransactionSchemas: [],
  partnerTransactionEmailTemplates: [],
  materialGroups: [],
  materialPackaging: [],
  materialReviewSubmittedBys: [],
  menuItems: [
    {
      label: "KPI", icon: "monitoring",
      items: [
        { label: "KPI Dashboard", icon: "monitoring", to: "/kpi/dashboard" },
      ]
    },
    {
      label: "Zendesk", icon: "support_agent",
      items: [
        { label: "Ticket Search", icon: "search", to: "/zendesk/ticket-search" },
      ]
    },
    {
      label: "Material", icon: "barcode",
      items: [
        { label: "Material Search", icon: "search", to: "/material/search" },
        { label: "Material Review", icon: "verified", to: "/material/review" }
      ]
    },
    {
      label: "Inventory", icon: "inventory_2",
      items: [
        { label: "Inventory Dashboard", icon: "inventory_2", to: "/inventory/dashboard" },
        { label: "Inventory Search", icon: "search", to: "/inventory/search" },
        { label: "Inventory Detail Search", icon: "manage_search", to: "/inventory/detail-search" },
        { label: "Inventory Adjustment Search", icon: "query_stats", to: "/inventory/adjustment-search" },
        { label: "Inventory Reconciliation", icon: "inventory", to: "/inventory/reconciliation" }
      ]
    },
    {
      label: "Order", icon: "package",
      items: [
        { label: "Order Dashboard", icon: "package", to: "/order/dashboard" },
        { label: "Order Metrics", icon: "analytics", to: "/order/metrics" },
        { label: "Order Search", icon: "search", to: "/order/search" },
        { label: "Order Line Search", icon: "manage_search", to: "/order/line-search" },
        { label: "Create Inbound Order", icon: "draft_orders", to: "/order/create-inbound" },
        { label: "Create Outbound Order", icon: "draft_orders", to: "/order/create-outbound" }
      ]
    },
    {
      label: "Operations", icon: "local_shipping",
      items: [
        { label: "Operations Dashboard", icon: "checklist", to: "/operations/dashboard" }
      ]
    },
    {
      label: "Administration", icon: "home_repair_service",
      items: [
        { label: "Organization", icon: "account_tree", to: "/administration/organization" },
        { label: "Project", icon: "corporate_fare", to: "/administration/project" },
        { label: "User", icon: "group", to: "/administration/user" },
        { label: "Warehouse", icon: "warehouse", to: "/administration/warehouse" },
        { label: "Warehouse Matrix", icon: "family_history", to: "/administration/warehouse-matrix" },
        { label: "Template", icon: "integration_instructions", to: "/administration/template" },
        { label: "Scheduled Report", icon: "summarize", to: "/administration/scheduled-report" },
        { label: "Order Configuration", icon: "manufacturing", to: "/administration/order-configuration" }
      ]
    },
    {
      label: "Engineering", icon: "code_blocks",
      items: [
        { label: "Partner", icon: "handshake", to: "/engineering/partner" },
        { label: "Partner Transaction", icon: "sync_alt", to: "/engineering/partner-transaction" },
        { label: "Payload Tracker", icon: "data_object", to: "/engineering/payload-tracker" }
      ]
    },
    {
      label: "Data Insights", icon: "insights",
      items: []
    },
  ],
  isAppSettingsPanelVisible: false,
  zendeskWidget: {
    isAvailable: true,
    isVisible: false
  },
  fileViewerDialog: {
    isVisible: false,
    fileName: "",
    blob: null,
    carousel: null
  }
});